import React, { useEffect, useState } from 'react';
import _cloneDeep from 'lodash/cloneDeep';
import styles from './types.module.scss';
import ActivityEditor from 'packages/workflow/activityType';
import { ATYPE } from '../customersList/constant';
import { ClientsAPI } from '../customers.service';
import { KoLoader } from 'packages';
export default function CustomerActivityType() {
  const [loader, setLoader] = useState(true);
  const [accountType, setAccountType] = useState(ATYPE);


  useEffect(() => {
    getAccountType();
  }, []);


  const updateTypeData = async(data) => {
    const cloned = await _cloneDeep(data);
    console.log(cloned);
    setAccountType(data?.activityTypes);
  };

  const getAccountType = async() => {
    setLoader(true);
    try {
      const res = await ClientsAPI.getCustomerTypes();
      if (res) {
        setAccountType();
        setAccountType(res);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error('Error fetching account types:', error);
    }
  };

  
  const updateType = async(data) => {
    setLoader(true);
    try {
      const res = await ClientsAPI.updateCustomerTypes({type:accountType});
      if (res) {
        await getAccountType();
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error('Error updating account type:', error);
    }
  };


  return (
    <div className={styles.wrapper}>
      {loader && <KoLoader />}
      <ActivityEditor customAction={[{
        label:'Save Types',
        color:"default", variant:"solid",
        onClick:()=>(updateType('save'))
      }]} workspace={{status: 0}} setTemplateModal={()=>(console.log(''))} data={{name:'Account Type', activityTypes: accountType?.length > 0 ? accountType : ATYPE}}  onChange={(data)=>(updateTypeData(data))} height={'calc(100vh - 45rem)'} />
    </div>
  );
}
